// extracted by mini-css-extract-plugin
export default {"footer":"FuwFooter_footer__UOAuH","text":"FuwFooter_text__cjOnp"};